/**
 * Fallback for browsers without oklch relative color syntax.
 * Computes luminance of brand-colored backgrounds and sets
 * appropriate contrast text colors as CSS custom properties.
 * No-op if oklch is supported or if brand vars aren't set.
 */
export function applyContrastFallback(): void {
  if (CSS.supports('color: oklch(from red l c h / 0.5)')) return;

  const temp = document.createElement('div');
  temp.style.position = 'absolute';
  temp.style.visibility = 'hidden';
  document.body.appendChild(temp);

  const ctx = document.createElement('canvas').getContext('2d')!;

  function getContrastText(cssVar: string): string | null {
    temp.style.background = '';
    temp.style.background = `var(${cssVar})`;
    // Use canvas to normalise any color format (oklch, etc.) to sRGB
    ctx.fillStyle = '#000';
    ctx.fillStyle = getComputedStyle(temp).backgroundColor;
    ctx.fillRect(0, 0, 1, 1);
    const [r, g, b, a] = ctx.getImageData(0, 0, 1, 1).data;
    if (a === 0) return null;
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#1C1917' : '#FFFFFF';
  }

  const root = document.documentElement;
  const pairs: [string, string][] = [
    ['--ch-btn-text', '--ch-btn-bg'],
    ['--ch-on-accent', '--ch-accent'],
    ['--ch-on-bg', '--ch-bg'],
    ['--ch-on-surface', '--ch-surface'],
  ];

  for (const [textVar, bgVar] of pairs) {
    const color = getContrastText(bgVar);
    if (color) root.style.setProperty(textVar, color);
  }

  temp.remove();
}
